import request from '@/utils/request' // 引入封装的request.js文件


export function Policy(query) {
  return request({
    url: '/bolan/calendar/',
    method: 'get',
    params: query
  })
}

export function Investment(query) {
  return request({
    url: '/bolan/calendar/',
    method: 'get',
    params: query
  })
}

export function Opportunity(query) {
  return request({
    url: '/bolan/calendar/',
    method: 'get',
    params: query
  })
}

export function Data(query) {
  return request({
    url: '/bolan/calendar/',
    method: 'get',
    params: query
  })
}


export function HseCalendar(query) {
  return request({
    url: '/bolan/calendar/',
    method: 'get',
    params: query
  })
}



// WEBPACK FOOTER //
// ./src/api/calendar.js